<div class="border bg-white rounded-lg border-[#d3dce8] p-6">
  <div class="h-10 flex">
    <button
      class="h-10 w-[33%] cursor-pointer font-semibold text-[16px] border border-[#25508E]"
      style="border-radius: 4px 0px 0px 4px"
      [ngClass]="enableTab == 'Preview' ? 'bg-[#25508E] text-white' : 'text-[#25508E] bg-transparent hover:bg-[#EBF0FA]'"
      (click)="enableTab = 'Preview'"
    >
      Preview
    </button>
    <button
      class="h-10 w-[33%] cursor-pointer font-semibold text-[16px] border border-[#25508E]"
      style="border-radius: 0px"
      [ngClass]="enableTab == 'Summary' ? 'bg-[#25508E] text-white' : 'text-[#25508E] bg-transparent hover:bg-[#EBF0FA]'"
      (click)="enableTab = 'Summary'; getAiData()"
    >
      Summary
    </button>
    @if(is_password_protected){
    <button
      class="explore-ai-btn h-10 w-[33%] font-semibold text-[16px] flex items-center justify-center gap-2"
      style="background: #c1c2c5; color: white"
    >
      <img src="assets/images/ai-suggestion-icon-white.svg" class="w-4 h-4 ai-icon" />
      <span>Explore</span>
    </button>

    }@else{
    <button
      class="explore-ai-btn h-10 w-[33%] cursor-pointer font-semibold text-[16px] flex items-center justify-center gap-2 transition-all duration-200"
      [ngClass]="{
        'explore-ai-btn--active': enableTab == 'Explore with Ai',
        'explore-ai-btn--hover': isHovering && enableTab != 'Explore with Ai',
        'explore-ai-btn--normal': !isHovering && enableTab != 'Explore with Ai'
      }"
      (mouseenter)="isHovering = true"
      (mouseleave)="isHovering = false"
      (click)="enableTab = 'Explore with Ai'; getAiData()"
    >
      <img src="assets/images/Ai-icon.svg" class="w-4 h-4 ai-icon" />
      <span>Explore</span>
    </button>

    }
  </div>
  <div class="relative mt-4 flex border border-[#d3dce8] rounded-lg bg-[#F9FAFC] h-[650px] p-4 border-dashed">
    @if(enableTab == 'Preview'){ @for(file of files; track file.id){ @if(is_password_protected){ @if(is_removing_password){
    <div style="margin-top: 164px; width: 100%">
      <div style="margin: auto; width: 180px">
        <ng-lottie [options]="animation"></ng-lottie>
      </div>
      <p class="text-[#53565B] font-semibold text-base m-0" style="line-height: 36px !important; text-align: center">
        One moment while <span class="text-[#25508E] font-bold"> Kinnect AI </span> processes this document...
      </p>
    </div>
    }@else{
    <div class="w-full rounded bg-[#ebf0fa]" (click)="openPasswordProtectedDialog()">
      <div class="flex cursor-pointer flex-col m-auto" style="width: 208px; margin-top: 144px !important">
        <img src="assets/images/lock.svg" style="width: 120px; margin: 24px auto" />
        <p class="text-[#18191c] font-semibold text-lg">Password Protected File</p>
        <button class="bg-[#25508E] text-white text-xs font-semibold px-4 py-2 rounded-md">Remove Password</button>
      </div>
    </div>
    } }@else{
    <file-extension-preview
      style="width: 100%; border-radius: 4px; cursor: pointer; text-align: center"
      [IconName]="file | materialIconName"
      [link]="file.link"
      [is_full_size_icon]="true"
      [link_available]="false"
      [index]="0"
      [file]="file"
      [formFileExtension]="true"
      (childToParent)="getUrl($event.param1, $event.param2, $event.param3, $event.param4)"
      [isActive]="file.isActive"
    >
    </file-extension-preview>
    }
    <div class="absolute top-8 right-8 flex gap-1 items-center h-6 z-10 hover:cursor-pointer">
      <div class="relative">
        <span
          #dateButton
          class="h-8 text-sm font-semibold gap-2 px-3"
          [ngClass]="{ 'disabled-attachment-tag-container': isRemoveEditSaveSharing, 'setup-tag-container': !isRemoveEditSaveSharing }"
          (click)="!isRemoveEditSaveSharing ? openDatePicker(file) : null"
        >
          <span> {{ file?.document_date ? (file.document_date | date : 'MMMM dd, yyyy') : 'Add Date' }} </span>
          <img [src]="file?.document_date ? 'assets/images/attachment_date_green.svg' : 'assets/images/attachment_date_blue.svg'" />
        </span>
        <mat-form-field class="absolute top-0 left-0 w-0 h-0 overflow-hidden opacity-0">
          <mat-label>Select Date</mat-label>
          <input matInput [matDatepicker]="picker" #dateInput (dateChange)="onDateChange($event)" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <span
        class="h-8 text-sm font-semibold gap-2 px-3"
        [matTooltip]="file?.form_name"
          [ngClass]="{ 'disabled-attachment-tag-container': isRemoveEditSaveSharing, 'setup-tag-container': !isRemoveEditSaveSharing }"
        (click)="!isRemoveEditSaveSharing ? manageLocation(file) : null"
      >
        <span> {{ (file?.form_name ? file.form_name : 'Add Location') | truncateStrPipe : 20 }} </span>
        @if(file?.form_name){
        <img src="assets/images/location_green.svg" />
        }@else{
        <img class="relative" src="assets/images/location_blue.svg" />
        }
      </span>
    </div>
    } }@else if(enableTab == 'Summary'){
    <div class="w-full">
      @if(isUpdatingSummary){
      <div class="h-[calc(100%-42px)] w-fyll">
        <div class="text-[#18191c] text-sm font-open-sans font-bold mb-[12px]">Updating Summary...</div>
        <div class="w-full h-full">
          <div class="ph-item border-none bg-transparent p-0">
            <div class="ph-col-12">
              <div class="ph-row">
                <div class="ph-col-12 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
              </div>
              <div class="ph-row">
                <div class="ph-col-6 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }@else{
      <div class="flex justify-between items-center mb-[10px]" [ngClass]="{ 'justify-end': !summaryData, 'justify-between': summaryData }">
        @if(summaryData && !is_loading){
        <div class="text-[#18191c] text-base font-bold font-open-sans">Here's a summary of {{ files[0].name }}</div>
        }
        <div>
          @if(summaryData && !is_loading){
          <button class="update-summary-btn px-3 py-1 flex items-center gap-1" (click)="updateSummaryData()">
            <mat-icon class="texr-[#FFFFFF] leading-[20px] text-xl w-5 h-5">refresh</mat-icon> Update
          </button>
          }@else{
          <button class="update-summary-btn px-3 py-1 flex items-center gap-1" (click)="updateSummaryData()">
            <mat-icon class="texr-[#FFFFFF] leading-[20px] text-xl w-5 h-5">refresh</mat-icon> Refresh
          </button>
          }
        </div>
      </div>
      <div class="w-full h-[calc(100%-42px)] overflow-auto">
        @if(is_loading){
        <div class="w-full h-full">
          <div class="ph-item border-none bg-transparent p-0">
            <div class="ph-col-12">
              <div class="ph-row">
                <div class="ph-col-12 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
              </div>
              <div class="ph-row">
                <div class="ph-col-6 big h-[30px] bg-[#D9D9D9] rounded-[4px]"></div>
              </div>
            </div>
          </div>
        </div>
        }@else{ @if(summaryData){
        <div [innerHTML]="summaryData" style="white-space: pre-line; overflow: auto" class="text-[#18191c] text-sm font-open-sans"></div>
        }@else{
        <div class="flex flex-col items-center justify-center h-full w-full">
          <div><img src="assets/images/state-zero/summery-doc.svg" class="w-[57px] h-[57px]" /></div>
          <div class="text-[#18191C] font-semibold text-base font-open-sans mt-[12px]">Attach Readable Documents To Create Summary</div>
          <div class="w-[485px] text-center text-[#707070] text-sm font-open-sans leading-[23px] letter-spacing-[0.168px] font-medium mt-[12px]">
            In order to create a summary, a readable document needs to be attached to this template. If a readable document is already attached, click
            on <span class="text-[#25508E] font-bold cursor-pointer" (click)="updateSummaryData()">Refresh</span>.
          </div>
        </div>
        } }
      </div>
      }
    </div>
    }@else if(isShowExploreWithAiChat){
    <div class="w-full h-full overflow-auto">
      <explore-with-ai-chat
        [currentTemplate]="currentTemplate"
        [summaryData]="summaryData"
        [vault_user_form_id]="currentFormId"
      ></explore-with-ai-chat>
    </div>
    }
  </div>
</div>
